export const mypage = {
  heading: 'My Page',
  logout: 'Log out',

  // Section headings
  nextLessonTitle: 'Next Lesson',
  planTitle: 'Plan & Remaining',
  pastLessonsTitle: 'Past Lessons',
  profileTitle: 'Profile',
  menuTitle: 'Menu',

  // Next lesson
  joinMeet: 'Join Google Meet',
  sendNextSchedule: 'Please send your next lesson schedule',
  sendPreferred: 'Send preferred times →',
  waitingMatch: 'Waiting to be matched. We will email you once it is confirmed.',
  partner: 'Partner: ',

  // Plan & remaining
  noPlan: 'Subscribe to a plan to start taking lessons',
  viewPlans: 'View plans →',
  remainingLessons: 'Remaining lessons',
  rolloverLessons: 'Rollover',
  nextRenewal: 'Next renewal: ',
  planLabels: {
    basic: 'Basic (4 / month)',
    plus2: 'Plus 2 (6 / month)',
    plus4: 'Plus 4 (8 / month)',
  },
  subscriptionStatus: {
    none: 'None',
    active: 'Active',
    paused: 'Paused',
    cancelled: 'Cancelled',
    past_due: 'Payment pending',
  },

  // Past lessons
  fillForm: 'Fill out form →',

  // Profile
  name: 'Name',
  email: 'Email',
  country: 'Country',
  timezone: 'Time zone',
  nativeLanguages: 'Native languages',
  learningLanguages: 'Learning languages',
  editProfile: 'Edit profile →',

  // Menu
  menu: {
    curriculum: '🗺️ Curriculum progress',
    schedule: '📅 Send preferred lesson times',
    plans: '💳 Choose / change plan',
    wordPool: '📖 Word Pool',
    addWord: '✏️ Add a word',
    postLesson: '📝 Post-lesson form',
    levelCheck: '🎯 Level check',
    additionalLesson: '➕ Request additional lesson',
    contact: '📬 Contact',
    orgSchedule: '👥 Organization schedule',
    adminDashboard: '🛠️ Admin dashboard',
    adminMatching: '🔧 Matching admin',
    adminWordPool: '🔧 Word Pool review',
    adminLevelCheck: '🔧 Level check results',
  },
};
